import { LitElement, html, css } from "lit";
import { customElement, state } from "lit/decorators.js";

@customElement("auto-info")
export class AutoInfo extends LitElement {
  @state() channel: BroadcastChannel;
  @state() status: string;

  static styles = css`
    p {
      margin: 0;
      padding: 16px 0;
    }
  `;

  connectedCallback() {
    super.connectedCallback();
    this.channel = new BroadcastChannel("auto");
    this.channel.onmessage = function (e: Event) {
      this.status = e.data;
    }.bind(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.channel.close();
  }

  render() {
    return html`<p>${this.status}</p>`;
  }
}
